<template>
    <cadastro-simples-form
        endpoint="causa-baixo-desempenho"
        rota-base="/admin/causa-baixo-desempenho"
        titulo-singular="Causa de Baixo Desempenho"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
